import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { format } from "date-fns";

export default function GeneralesCard({id, numDocumento, nombre, cuitCuilDni, ciudad, direccion, cp, zona, telefono, fecha, total}) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLink = () => {
        navigate(`/documentoDetalle/${id}`)
    }

    return(
            <>
                <table>
                    <tbody>
                    <tr className="text-sky-300 text-[10pt] font-semibold border-b border-slate-400 hover:font-bold hover:text-yellow-300 cursor-pointer"
                        onClick={handleLink}
                    >                
                        <td className="text-[7pt] w-[60px] text-center md:w-[90px] md:text-[11pt]">{format(new Date(fecha), 'dd/MM/yyyy')}</td> 
                        <td className="text-[8pt] w-[55px] text-center md:w-[80px] md:text-[11pt]">{numDocumento}</td>
                        <td className="text-[8pt] w-[150px] md:w-[300px] md:text-[11pt]">{nombre}</td>
                        <td className="text-[8pt] w-[91px] text-center hidden sm:flex md:pl-3 md:w-[100px] md:text-[11pt]">{cuitCuilDni}</td>
                        <td className="text-[8pt] w-[91px] md:w-[150px] md:text-[11pt]">{ciudad}</td>
                        <td className="text-[8pt] w-[110px] md:w-[300px] md:text-[11pt]">{direccion}</td>
                        <td className="text-[8pt] hidden w-[50px] md:pl-3 md:flex md:pt-[6px] md:text-[11pt]">{cp}</td>
                        <td className="text-[8pt] md:text-[11pt] w-[45px] text-center">{zona}</td>
                        <td className="text-[8pt] hidden w-[110px]  md:pl-3 md:flex md:pt-[6px] md:text-[11pt]">{telefono}</td>
                        <td className="text-[8pt] text-right w-[110px] md:w-[100px] md:text-[11pt]">{total}</td>
                    </tr>                             
                    </tbody>
                </table>
            </>
        )
}